import { useSelector } from "react-redux";
import { RootState } from "../redux/reducers/index";
import { formatMoney } from "accounting";

const CurrencyFormat = ({amount, precision = 2}: any): any => {

    const {currency} = useSelector((state: RootState) => state.home);

    const currencyConverted = {
        "USD": formatMoney(amount, {symbol: "$", thousand: ",", decimal: ".", precision}),
        "COP": formatMoney(amount, {symbol: "$", thousand: ".", decimal: ",", precision}),
        "": formatMoney(amount, {symbol: "$", thousand: ".", decimal: ",", precision})
    }[currency]

    return `${currencyConverted} ${currency}`
    
}

export const roundValue = (value: number, precision: number = 3) => {
    return parseFloat(formatMoney(value, {symbol: "", thousand: "", decimal: ".", precision}))
}

export default CurrencyFormat